import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_59: FaireProductEntity = {
  token: "legacy_prod_abbott-59",
  type: "product",
  name: 'Small Pomegranate Shaped Bowl 4.5" L',
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/0d9320e47c56cfa2e68125fee6e99a94c52d1da9da7b9b35fe72772efb69434a.jpeg",
  priceDollars: 16,
  subcategory: "Serveware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
